import { render } from "./CategoryGrid.vue?vue&type=template&id=d8d06a34&scoped=true"
import script from "./CategoryGrid.vue?vue&type=script&lang=js"
export * from "./CategoryGrid.vue?vue&type=script&lang=js"

import "./CategoryGrid.vue?vue&type=style&index=0&id=d8d06a34&scoped=true&lang=css"

import exportComponent from "/home/walter/projects/finances-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d06a34"]])

export default __exports__